import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TextGold from '@/components/common/TextGold/TextGold';
import { useGames } from '@/Context/GameContext';
import styles from './CategoryStrip.module.css';

const ESPORTS_GAME_ID = '4ee8e0051a035b463b47c3c473ce317d';

const CARDS = [
  {
    id: 'sports',
    titleKey: 'common.sports',
    href: '/sports',
    mobImage: '/assets/images/category-strip/mobile-s.webp',
    deskBg: '/assets/images/category-strip/football.png',
    deskCh: '/assets/images/category-strip/photo-s.webp',
    icon: '/assets/images/category-strip/sport.svg',
  },
  {
    id: 'esport',
    titleKey: 'home.eSport',
    href: '/esports',
    mobImage: '/assets/images/category-strip/mobile-es.webp',
    deskBg: '/assets/images/category-strip/esports.png',
    deskCh: '/assets/images/category-strip/photo-es.webp',
    icon: '/assets/images/category-strip/esport.svg',
  },
  {
    id: 'casino',
    titleKey: 'common.casino',
    href: '/casino',
    mobImage: '/assets/images/category-strip/mobile-c.webp',
    deskBg: '/assets/images/category-strip/casino.png',
    deskCh: '/assets/images/category-strip/photo-c.webp',
    icon: '/assets/images/category-strip/casino.svg',
  },
];

const CategoryStrip = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleJsGameLaunch } = useGames();

  const handleCardClick = (card, e) => {
    if (card.id === 'esport') {
      e.preventDefault();
      handleJsGameLaunch(ESPORTS_GAME_ID, navigate);
    }
  };

  return (
    <div className={styles.section}>
      
      {/* Desktop layout - hidden on mobile */}
      <div className={styles.desktopWrap}>
        {CARDS.map((card) => (
          <Link
            key={card.id}
            to={card.href}
            className={styles.deskCard}
            aria-label={`Go to ${t(card.titleKey)}`}
            onClick={(e) => handleCardClick(card, e)}
          >
            <div className={styles.deskBgWrap}>
              <img
                alt="card background"
                loading="lazy"
                width="384"
                height="150"
                className={styles.deskBgImg}
                src={card.deskBg}
              />
            </div>
            {card.deskCh && (
              <div className={`${styles.deskChWrap}${card.id === 'sports' ? ` ${styles.deskChWrapSports}` : card.id === 'casino' ? ` ${styles.deskChWrapCasino}` : card.id === 'esport' ? ` ${styles.deskChWrapEsport}` : ''}`}>
                <img
                  alt=""
                  loading="lazy"
                  className={styles.deskChImg}
                  src={card.deskCh}
                />
              </div>
            )}
            <div className={styles.deskGradient} />
            <div className={styles.deskContent}>
              <div className={styles.deskInfo}>
                <div className={styles.deskTitleWrap}>
                  <p className={styles.deskTitle}>
                    <img alt={t(card.titleKey)} className={styles.deskIcon} src={card.icon} />
                    {t(card.titleKey)}
                  </p>
                </div>
                <div className={styles.deskArrow}>
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" className={styles.deskArrowSvg}>
                    <path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M10 7l5 5-5 5" />
                  </svg>
                </div>
              </div>
              <div className={styles.deskPlayBtn}>{t('home.playNow')}</div>
            </div>
          </Link>
        ))}
      </div>

      {/* Mobile layout - hidden on desktop */}
      <div className={styles.mobileWrap}>
        {CARDS.map((card) => (
          <Link
            key={card.id}
            to={card.href}
            className={styles.mobCard}
            aria-label={`Go to ${t(card.titleKey)}`}
            onClick={(e) => handleCardClick(card, e)}
          >
            <img
              alt=""
              loading="lazy"
              className={styles.mobImg}
              src={card.mobImage}
            />
            <div className={styles.mobGradient} />
            <div className={styles.mobContent}>
              <img alt="" className={styles.mobIcon} src={card.icon} />
              <p className={styles.mobLabel}>{t(card.titleKey)}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CategoryStrip;
